module.exports = __webpack_public_path__ + "static/media/Audio.3c76ad7c.svg";